import { AxiosResponse } from 'axios';
import { SaveDataAnpr } from 'shell/view-models/save-data-anpr';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprSaveData } from 'shell/models/person';

export const transformResponseSaveDataAnpr = (
  response: AxiosResponse<HttpResponse<ResponseAnprSaveData>>
): SaveDataAnpr => {
  return {
    warnings: (response.data.payload?.rispostaComune?.listaAnomalie?.errore || []).map(
      (warning) => ({
        id: warning.codiceErroreAnomalia,
        value: warning.testoErroreAnomalia,
      })
    ),
    errors: (response.data.payload?.rispostaKO?.listaErrori?.errore || []).map((error) => ({
      id: error.codiceErroreAnomalia,
      value: error.testoErroreAnomalia,
    })),
  };
};
